import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { MemberDetailService } from "../../platform/modules/member/member-detail/member-detail.service";
import { GridService } from "../grid/grid.service";
import { GridColumnDefinition } from "../grid/models/grid-column-definition.model";

@Component({
  selector: "app-member-grid-member-id",
  templateUrl: "./member-id.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberIdComponent {
  @Input() data: any;
  @Input() masterMemberIdRouteUrl: string;
  @Input() showMemberWithCharts: string;

  constructor(
    private router: Router,
    private gridService: GridService,
    private memberDetailService: MemberDetailService
  ) { }

  get masterMemberId(): number {
    return this.data.masterMemberId || this.data.masterMemberId;
  }

  get rowEnabled(): boolean {
    if (this.data.disabled != undefined && this.data.disabled != null) {
      return !this.data.disabled;
    } else {
      return true;
    }
  }

  navigateToMemberDetail(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    const url = this.gridService.generateLink(
      new GridColumnDefinition({ routeUrl: this.masterMemberIdRouteUrl } as any),
      this.data
    );
    this.memberDetailService.setShowMemberWithChasesFlag(this.showMemberWithCharts);
    this.router.navigateByUrl(url, { state: { ...this.data } });
  }
}
